// @ts-nocheck
import { ReactNode } from 'react'
import { StyledModal } from './styles'

interface CustomModalProps {
  isOpen: boolean
  onRequestClose?: () => void
  children?: ReactNode
}

export const CustomModal = ({
  isOpen,
  children,
  onRequestClose,
}: CustomModalProps) => {
  return (
    <StyledModal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      style={{
        overlay: {
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
        },
      }}
    >
      {children}
    </StyledModal>
  )
}
